<template>
  <v-card class="docs request-docs">
    <v-card-title>
      <div class="text-h5">{{ title }}</div>
    </v-card-title>
    <table>
      <thead>
      <tr>
        <th>Параметр</th>
        <th>Данные</th>
        <th class="org-comment__flag">&nbsp;</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="indicator in checklistConfig" :key="indicator.id">
        <td>
          {{ indicator.code }}. {{ indicator.name }}, {{ indicator.unit }}
        </td>
        <td class="org-comment__params">
          <div class="standard-docs-params">
            <v-text-field
                :value="parseFloat(findValueById(checklistValues, indicator.id)?.value)"
                @input="setChecklistValue(indicator.id, $event)"
                :disabled="isIndicatorDisabled(indicator)"
                placeholder="Значение"
                type="number"
            ></v-text-field>
          </div>
        </td>
        <td class="org-comment__flag">
          <template v-if="isImported(indicator)">
            Данные импортируются ({{ indicator.source }})
            <div v-if="indicator.manualInput" style="font-size: 11px; margin-top: 8px;">
              * Разрешен ручной ввод
            </div>
          </template>
        </td>
      </tr>

      <tr v-if="fileConfig">
        <td>
          <div >
            <h3 class="mb-3">Документы</h3>
            <div v-if="fileConfig.description" class="mb-3">
              {{ fileConfig.description }}
            </div>
            <v-row class="file-row align-center" v-for="attachment in attachments" :key="attachment.id">
              <v-col cols="12" lg="4">
                <a @click="downloadAttachment(attachment)" download class="file-link">
                  <v-icon class="icon-item icon-file-document-outline"></v-icon>
                  {{ truncateStr(attachment.name, 50) }}
                </a>
              </v-col>
              <v-col cols="12" lg="5" class="d-flex align-center" v-if="checkRoles(fileRoles) && period.status === 'OPEN'">
                <div class="delete ml-2" @click="deleteAttachment(attachment)">
                  <v-icon class="icon-item icon-delete-outline"></v-icon>
                </div>
              </v-col>
            </v-row>

            <template v-if="checkRoles(fileRoles) && period.status === 'OPEN'">
              <input type="file" ref="attachmentInput" style="display: none" @change="addAttachment()">
              <a @click="$refs['attachmentInput'].click()" class="configAdd mt-3">+ добавить файл</a>
            </template>
          </div>
        </td>
      </tr>
      </tbody>
    </table>

    <v-card-actions>
      <v-btn
          class="btn btn-outline"
          text
          @click="$emit('close')"
      >
        Отмена
      </v-btn>
      <v-btn
          class="btn btn-primary"
          @click="submit()"
          :disabled="period.status === 'CLOSED'"
      >
        Сохранить изменения
      </v-btn>
    </v-card-actions>

    <LoaderDialog :show="loading" msg="Загрузка"></LoaderDialog>
    <v-snackbar
        v-model="snackbar"
        :timeout="1500"
        text
        centered
        :color="snackbarError ? 'red' : 'green'"
    >
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn
            color="blue"
            text
            small
            v-bind="attrs"
            @click="snackbar = false"
        >
          Закрыть
        </v-btn>
      </template>
    </v-snackbar>
  </v-card>
</template>

<script>
import {saveIndicators} from "@/modules/api.indicators";
import {downloadFile, uploadFile} from "@/modules/api.files";
import LoaderDialog from "../elements/LoaderDialog.vue";
export default {
  name: 'ActivityMonitorEditDialog',
  components: {LoaderDialog},
  props: ['regionAndDepartmentInfo', 'title', 'checklistConfig', 'checklistValues', 'fileConfig', 'fileValues', 'period'],
  data: () => ({
    flags: ['#89FF8E', '#F8FC56', '#FF7272'],
    controllerRoles: ['ROLE_ADMIN', 'ROLE_VNII'],
    fileRoles: ['ROLE_ADMIN', 'ROLE_REGIONAL_AGENCY'],
    attachments: [],
    loading: false,
    snackbar: false,
    snackbarText: null,
    snackbarError: false,
  }),
  methods: {
    findValueById(values, id) {
      return values?.find(e => e.indicatorId === id);
    },
    getOrCreateValue(values, id, type) {
      let existingValue = this.findValueById(values, id);
      if (existingValue == null) {
        const department = this.regionAndDepartmentInfo.department == null
            ? null
            : this.regionAndDepartmentInfo.department
        existingValue = {
          regionCode: this.regionAndDepartmentInfo.region.code,
          cznId: department?.id,
          indicatorId: id,
          period: this.period.code,
          value: null,
          type,
        }
        values.push(existingValue);
      }
      return existingValue;
    },
    setChecklistValue(indicatorId, value) {
      this.getOrCreateValue(this.checklistValues, indicatorId, 'VALUE').value = value;
    },
    checkRoles(userRoles) {
      for (let role of userRoles) {
        if (this.$user.subroles.includes(role)) {
          return true;
        }
      }
      return false;
    },
    isImported(indicator) {
      // Для ТЦЗН - все данные вводятся пользователями
      if (this.regionAndDepartmentInfo.department != null) {
        return false;
      }

      return indicator.source !== 'РОИВ';
    },
    isIndicatorDisabled(indicator) {
      if (this.period.status === 'CLOSED') {
        return true;
      }
      if (this.checkRoles(['ROLE_ADMIN', 'ROLE_VNII'])) {
        return false;
      }
      return (this.isImported(indicator) && !this.checkRoles(this.controllerRoles) && !indicator.manualInput)
          || (!this.isImported(indicator) && this.checkRoles(this.controllerRoles));
    },
    openSnackbar(text, error = false) {
      this.snackbar = true;
      this.snackbarText = text;
      this.snackbarError = error;
    },
    truncateStr(str, n) {
      if (!str) return '';
      if (str.length > n) {
        return str.substring(0, n - 3) + "..." + str.substring(str.length - 6, str.length)
      }
      return str
    },
    async addAttachment() {
      const input = this.$refs['attachmentInput'];
      const file = input && input.files && input.files[0];

      if (file.size > 20 * 1024 * 1024) {
        const mb = (file.size / 1024 / 1024).toFixed(1);
        this.openSnackbar(`Размер файла ${mb} МБ превышает лимит 20 МБ.`, true);
        input.value = '';
        return;
      }

      const allowedExtensions = ['pdf', 'docx'];
      const extension = (file.name.split('.').pop() || '').toLowerCase();
      if (!allowedExtensions.includes(extension)) {
        this.openSnackbar('Недопустимый формат. Разрешены: PDF, DOCX.', true);
        input.value = '';
        return;
      }

      this.loading = true;
      if (file) {
        const uploadedFile = await uploadFile(file)
        this.attachments.push({
          id: uploadedFile.id,
          name: uploadedFile.name,
        });
      }

      this.$refs['attachmentInput'].value = ""
      this.$forceUpdate();
      this.loading = false;
    },
    async deleteAttachment(attachment) {
      this.attachments.splice(this.attachments.findIndex(e => e.id === attachment.id), 1);
      this.$forceUpdate();
    },
    async downloadAttachment(attachment) {
      this.loading = true;
      await downloadFile(attachment.id, attachment.name);
      this.loading = false;
    },
    async submit() {
      if (this.fileConfig) {
        let indicatorFile = this.getOrCreateValue(this.fileValues, this.fileConfig.id, 'FILES');
        indicatorFile.value = JSON.stringify(this.attachments);
        await saveIndicators([indicatorFile]);
      }

      await saveIndicators(this.checklistValues);
      this.$emit('updated', this);
    }
  },
  async beforeMount() {
    if (this.fileConfig) {
      const indicatorValue = this.fileValues?.find(e => e.indicatorId === this.fileConfig.id);
      try {
        this.attachments = JSON.parse(indicatorValue?.value);
      } catch (e) {
        console.log(e);
      }
    }
  }
}
</script>

<style scoped lang="scss">
.standard-docs-params {
  gap: 10px;
}

.standard-docs-file {
  padding-left: 25px;
  background: url(~@/assets/attach.svg) no-repeat left center;
}

.standard-docs-comment {
  background: url(~@/assets/chat.svg) no-repeat left center;
  padding-left: 25px;
}

.org-comment__control {
  min-width: 200px;
}

.org-comment__flag {
  & > div {
    position: relative;
    min-width: 40px;

    input[type="radio"] {
      display: none;
    }

    label {
      display: block;
      height: 16px;

      &:before {
        content: '';
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 16px;
        height: 16px;
        border-radius: 10px;
        background: #fff;
        border: 1px solid $cblue;
      }
    }

    input:checked + label:after {
      content: '';
      position: absolute;
      right: 4px;
      top: calc(50%);
      transform: translateY(-50%);
      width: 8px;
      height: 8px;
      border-radius: 50%;
      transition: all 0.2s;
      background: $cblue;
    }
  }

  & > div + div {
    margin-top: 5px;
  }
}
</style>
